:host {
  display: inherit;
}

iframe {
  aspect-ratio: 16 / 9;
  width: 100%;
}
